// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__th4_z","col":"styles_col__Z5yM5"};